import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { FRONTEND_ASSET_HOST } from '@sorare/core/src/constants/assets';

type TeamMember = {
  name: string;
  role: ReactNode;
  pictureUrl?: string;
  bio?: ReactNode;
};
export const founders: TeamMember[] = [
  {
    name: 'Nicolas Julia',
    role: (
      <FormattedMessage
        id="teamMembers.julia.role"
        defaultMessage="CEO and Co-founder"
      />
    ),
    pictureUrl: `${FRONTEND_ASSET_HOST}/pages/press/team/nicolasJulia.jpg`,
  },
  {
    name: 'Adrien Montfort',
    role: (
      <FormattedMessage
        id="teamMembers.montfort.role"
        defaultMessage="CTO and Co-founder"
      />
    ),
    pictureUrl: `${FRONTEND_ASSET_HOST}/pages/press/team/adrienMontfort.jpg`,
  },
];

export const leadershipTeam: TeamMember[] = [
  {
    name: 'Gabrielle Dorais',
    role: (
      <FormattedMessage
        id="teamMembers.gdorais.role"
        defaultMessage="Chief Business and Legal Officer"
      />
    ),
    pictureUrl: `${FRONTEND_ASSET_HOST}/pages/press/team/gabrielleDorais.jpg`,
  },
  {
    name: 'Thibaut Predhomme',
    role: (
      <FormattedMessage
        id="teamMembers.predhomme.role"
        defaultMessage="Chief of Staff"
      />
    ),
    pictureUrl: `${FRONTEND_ASSET_HOST}/pages/press/team/thibautPredhomme.jpg`,
  },
  {
    name: 'Julien Fontan',
    pictureUrl: `${FRONTEND_ASSET_HOST}/pages/press/team/julienFontan.jpg`,
    role: (
      <FormattedMessage
        id="teamMembers.fontan.role"
        defaultMessage="Head of Marketing"
      />
    ),
  },
];
